import React, { useState, useEffect } from 'react';
import '../../entrydoor.css';
import { authFetchRequest } from '../../utils/api';
import { getCookie } from '../../utils/cookies';

const UpPrice = ({ id = "upPrice", value, onChange, label = 'UpPrice (%)', disabled = false }) => {
  const [upPriceValue, setUpPriceValue] = useState(value || 0);
  const [updateMessage, setUpdateMessage] = useState('');

  useEffect(() => {
    setUpPriceValue(value || 0);
  }, [value]);

  const handleChange = (e) => {
    const val = e.target.value;
    if (/^\d*$/.test(val)) {  // Allow only integers
      setUpPriceValue(val);
      onChange(val); // Notify parent
    }
  };

  const handleUpdate = async () => {
    setUpdateMessage('');
    const userId = getCookie('user_id') || 0;
  
    try {
      const result = await authFetchRequest(
        `/users/${userId}/field/upPrice`,
        { value: parseInt(upPriceValue, 10) },
        'PUT',
        { Authorization: `Bearer ${getCookie("access_token")}` }
      );
      setUpdateMessage(result.message || 'UpPrice updated ✔️');
    } catch (err) {
      console.error('UpPrice update failed:', err);
      setUpdateMessage('Failed to update UpPrice ❌');
    }
  };
  

  return (
    <div className="a-container">
      <label htmlFor={id}>{label}</label>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <input
          type="text"
          disabled={disabled}
          id={id}
          value={upPriceValue}
          onChange={handleChange}
          className="p-2 border rounded-md w-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          onClick={handleUpdate}
          disabled={disabled}
          className="px-3 py-1 bg-green-600 text-white rounded hover:bg-green-700"
        >
          Update
        </button>
      </div>
      {updateMessage && (
        <div style={{ marginTop: '5px', fontSize: '0.85rem', color: updateMessage.includes('✔️') ? 'green' : 'red' }}>
          {updateMessage}
        </div>
      )}
    </div>
  );
};

export default UpPrice;
